module.exports = __webpack_public_path__ + "img/restore-deleted-messages-gb-whatsapp.8c6ea69d.jpg";